import React from "react";
import styles from "./style.module.css";
import location from "../../../../assets/locationPin.png";
import AdChart from "./AdChart";
function ViewAdStats() {
  return (
    <div className={styles.MainContainer}>
      <div className={styles.breadCrumb}>
        <span onClick={()=>window.location.reload("/Partner")}>
          All Advertisement {">"}{" "}
          <b style={{ opacity: "100%", color: "#131313" }}>
            Advertisement Stats
          </b>
        </span>
      </div>
      <div className={styles.adDetails}>
        <p>Black Friday Offer</p>
        <p>Check Out Baskin Robins</p>
        <div className={styles.location}>
          <img src={location} alt="" /> <p>Berlin</p>
        </div>
        <div className={styles.adContent}>
          <p>Hungry for burgers or a nice salad?</p>
          <p>Then you better visit this place.</p>
        </div>
        <div className={styles.adInfo}>
          <div className={styles.adType}>
            <p>Ad Type</p>
            <p>In Feed</p>
          </div>
          <div className={styles.adType}>
            <p>Released On</p>
            <p>7th Feb 2023,8:00</p>
          </div>
        </div>
      </div>
      <div className={styles.chart}>
        <AdChart/>
      </div>
    </div>
  );
}

export default ViewAdStats;
